// Single source of truth for the machine-readable facts about the IKEM
// training. The wording visitors read lives in the translations (training.*);
// these values drive the automatic hiding of the section once the training is
// over (see helpers/showsIkemTraining.ts) and the schema.org markup emitted by
// the section itself.
//
// October 2026 is still CEST (the switch happens on 25 October), hence +02:00.
export const IkemTraining = {
  start: '2026-10-20T09:30:00+02:00',
  end: '2026-10-20T16:30:00+02:00',
  // The announcement stays up until the end of the training day.
  hideAfter: '2026-10-20T23:59:59+02:00',
  registrationEnds: '2026-10-14T23:59:59+02:00',
  currency: 'CZK',
  // Price per person, without VAT.
  price: 3000,
  venue: {
    streetAddress: 'Vídeňská 1958/9',
    postalCode: '140 21',
    addressLocality: 'Praha',
    addressCountry: 'CZ',
  },
};
